import { createFileRoute } from '@tanstack/react-router';
import { NewBundlePage } from '../../../features/studio/pages/new.tsx';

export const Route = createFileRoute('/_app/studio/new')({ component: NewBundlePage });
